import { render, staticRenderFns } from "./ProductAvailability.vue?vue&type=template&id=ad32e476&"
import script from "~/themes/oknanebodvere/components/product/ProductAvailability/ProductAvailability.js?vue&type=script&lang=js&"
export * from "~/themes/oknanebodvere/components/product/ProductAvailability/ProductAvailability.js?vue&type=script&lang=js&"
import style0 from "./ProductAvailability.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports